module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-comment-b9f342ff36d5777a907712777f9444b2.svg";